import axios from 'axios';
import { TENANCY_ENABLED, normalizePortalHost } from './tenant';

export const API_BASE_URL = process.env.API_BASE_URL || 'https://api.vnvjntdc.org/api/';

function tenantRequest(url, host) {
  const target = new URL(url, window.location.origin);
  const apiHosts = ['api.vnvjntdc.org', 'api.msobcfdc.in'];
  const configuredApi = new URL(API_BASE_URL);
  const isConfiguredApi = target.origin === configuredApi.origin;
  const isSharedApi = target.protocol === 'https:' && apiHosts.indexOf(target.hostname) !== -1;
  if ((!isConfiguredApi && !isSharedApi) ||
      target.pathname.indexOf('/api/') !== 0) {
    return null;
  }
  return {
    url: API_BASE_URL + target.pathname.slice('/api/'.length) + target.search,
    host: normalizePortalHost(host)
  };
}

export function installTenantHttp(Vue, store, host) {
  if (!TENANCY_ENABLED) return;
  normalizePortalHost(host);
  Vue.http.interceptors.push((request, next) => {
    const context = tenantRequest(request.url, host);
    if (context) {
      request.url = context.url;
      request.headers.set('X-Portal-Host', context.host);
    }
    next();
  });
  axios.interceptors.request.use(config => {
    const context = tenantRequest(config.url, host);
    if (context) {
      config.url = context.url;
      config.headers = config.headers || {};
      config.headers['X-Portal-Host'] = context.host;
      if (store.getters.authToken) {
        config.headers.Authorization = 'Bearer ' + store.getters.authToken;
      }
    }
    return config;
  });
}



// WEBPACK FOOTER //
// ./src/services/tenantHttp.js